//export const server = state => state.server

export const isPlugin = state => state.isPlugin

export const isAgent = state => state.isAgent

export const appConf = state => state.appConf

export const isLogged = state => state.logged

export const isSecondLevel = state => state.isSecondLevel

export const goToObject = state => state.goToObject

export const langVariant = state => state.langVariant

export const currentUser = state => state.currentUser
export const usersQuantity = state => state.usersQuantity
export const isSettings = state => state.isSettings

export const isAlert = state => state.isAlert

export const alertObject = state => state.alertObject

export const loader = state => state.loader

export const isModalComponent = state => state.isModalComponent

export const modalComponentObject = state => state.modalComponentObject

export const isModalSearchPartsComponent = state => state.isModalSearchPartsComponent

export const modalSearchPartsComponentObject = state => state.modalSearchPartsComponentObject

export const alertTable = state => state.alertTable

export const dataNotifications = state => state.dataNotifications

export const saveStatus = state => state.saveStatus

export const viewForModule = state => state.viewForModule

export const sectionPrefix = state => state.sectionPrefix

export const outerData = state => state.outerData

export const alertContainer = state => state.alertContainer

export const routingData = state => state.routingData
export const tabData = state => state.tabData

//S - Settings

export const s_skinVariant = state => state.s_skinVariant

export const selectedUser = state => state.selectedUser

export const globalSettings = state => state.globalSettings

//U - Users

export const createUserForm = state => state.createUserForm

//permissions

export const createGroupForm = state => state.createGroupForm
export const permissionGroup = state => state.permissionGroup

//All
export const dataTree = state => state.dataTree

export const dataSearchPartsTree = state => state.dataSearchPartsTree

export const selectedTreeItem = state => state.selectedTreeItem

export const reloadAfterDeleteTreeItem = state => state.reloadAfterDeleteTreeItem

export const selectedTreeItemObject = state => state.selectedTreeItemObject

export const selectedSearchPartsTreeItem = state => state.selectedSearchPartsTreeItem

export const selectedSearchPartsTreeItemObject = state => state.selectedSearchPartsTreeItemObject

export const authorityToChange = state => state.authorityToChange

export const elementCategory = state => state.elementCategory

export const elementCategorySearchParts = state => state.elementCategorySearchParts

export const dataTable = state => state.dataTable

export const selectedRows = state => state.selectedRows

//export const selectedRowsSearch = state => state.selectedRowsSearch

export const filters = state => state.filters

export const revisionHistory = state => state.revisionHistory

export const detailsData = state => state.detailsData

export const selectedRevisionRow = state => state.selectedRevisionRow

export const formDetailsData = state => state.formDetailsData

export const selectedFormRow = state => state.selectedFormRow

export const formTableInstance = state => state.formTableInstance

export const selectedIndexFormRow = state => state.selectedIndexFormRow

export const formProperty = state => state.formProperty
export const createPropertyForm = state => state.createPropertyForm
export const isEditPropertyForm = state => state.isEditPropertyForm
export const propertyToSaving = state => state.propertyToSaving
export const propertyToSavingUL = state => state.propertyToSavingUL
export const libraryFilesToSaving = state => state.libraryFilesToSaving
export const partRevisionId = state => state.partRevisionId

export const pinsTable = state => state.pinsTable
export const pinsTableDetails = state => state.pinsTableDetails

export const dependOnTable = state => state.dependOnTable
export const dependOnTableDetails = state => state.dependOnTableDetails

export const useInTable = state => state.useInTable
export const useInTableDetails = state => state.useInTableDetails

export const tasksTable = state => state.tasksTable
export const tasksTableDetails = state => state.tasksTableDetails

export const eventTaskResponse = state => state.eventTaskResponse

export const possibleValueForCombo = state => state.possibleValueForCombo

export const dataTableSearched = state => state.dataTableSearched

export const searchingObject = state => state.searchingObject

export const processId = state => state.processId

// export const symbolsTable = state => state.symbolsTable

// export const footprintsTable = state => state.footprintsTable

export const selectedFootprints = state => state.selectedFootprints

export const selectedSymbols = state => state.selectedSymbols

export const selectedAltSymbols = state => state.selectedAltSymbols


export const categoryMapping = state => state.categoryMapping

export const filteredData = state => state.filteredData

export const propertyId = state => state.propertyId

export const reloadedAfterActionComplex = state => state.reloadedAfterActionComplex

export const externalSearchResponseResult = state => state.externalSearchResponseResult

export const selectedSearchedRows = state => state.selectedSearchedRows

export const derivedNewProps = state => state.derivedNewProps

export const pm_activeFilters = state => state.pm_activeFilters
export const lm_activeFilters = state => state.lm_activeFilters
export const projm_activeFilters =  state => state.projm_activeFilters
export const pm_activeActions = state => state.pm_activeActions
export const lm_activeActions = state => state.lm_activeActions
export const projm_activeActions = state => state.projm_activeActions

export const notImportedParts = state => state.notImportedParts

export const duplicatePartNumber = state => state.duplicatePartNumber

export const currentSymbol = state => state.currentSymbol

export const newRenamingValue = state => state.newRenamingValue
export const newMovingCategory = state => state.newMovingCategory
export const delegationForm = state => state.delegationForm
export const transferOwnershipForm = state => state.transferOwnershipForm

//D - Dashboard

export const d_dashboardWidgets = state => state.d_dashboardWidgets

export const d_filteredData = state => state.d_filteredData

export const d_widgetsSettings = state => state.d_widgetsSettings

//PM - PartManager

export const previewParts = state => state.previewParts
export const importedFileId = state => state.importedFileId
export const mappedFields = state => state.mappedFields

export const eventTaskForm = state => state.eventTaskForm

export const alternativePartsToBind = state => state.alternativePartsToBind

export const selectedAlternative = state => state.selectedAlternative

export const allActiveImportedParts = state => state.allActiveImportedParts

export const existingTypes = state => state.existingTypes

export const newSubCategory = state => state.newSubCategory

export const newAssemblyForm = state => state.newAssemblyForm

export const selectedAssemblyRow = state => state.selectedAssemblyRow

export const assemblyQuantity = state => state.assemblyQuantity

export const tabStatus = state => state.tabStatus

export const libraryULObject = state => state.libraryULObject

export const buttonsStateModalObject = state => state.buttonsStateModalObject

//export const pm_dataTable = state => state.pm_dataTable

//export const pm_dataTree = state => state.pm_dataTree

//export const pm_selectedTreeItem = state => state.pm_selectedTreeItem

//export const pm_filters = state => state.pm_filters

//export const pm_activeFilters = state => state.pm_activeFilters

//export const pm_partCategory = state => state.pm_partCategory

//export const pm_selectedRows = state => state.pm_selectedRows

//LM - LibraryManager

export const categoryLibraryMapping = state => state.categoryLibraryMapping
export const dataLibraryTree = state => state.dataLibraryTree
//export const reloadTreeLibraryComponet = state => state.reloadTreeLibraryComponet
export const reloadAfterDeleteTreeLibraryItem = state => state.reloadAfterDeleteTreeLibraryItem
export const selectedTreeLibraryItemObject = state => state.selectedTreeLibraryItemObject

export const libStatuses = state => state.libStatuses

//export const lm_dataTable = state => state.lm_dataTable

//export const lm_dataTree = state => state.lm_dataTree

//export const lm_selectedTreeItem = state => state.lm_selectedTreeItem

//export const lm_filters = state => state.lm_filters

//export const lm_activeFilters = state => state.lm_activeFilters

//export const lm_partCategory = state => state.lm_partCategory

//export const lm_selectedRows = state => state.lm_selectedRows

//P - ProcesssesManager

export const p_showProcessDiagram = state => state.p_showProcessDiagram

// projm - Projects



export const dataProjectTree = state => state.dataProjectTree
export const categoryProjectMapping = state => state.categoryProjectMapping
//export const reloadTreeProjectComponet = state => state.reloadTreeProjectComponet
export const reloadAfterDeleteTreeProjectItem = state => state.reloadAfterDeleteTreeProjectItem
export const selectedTreeProjectItemObject = state => state.selectedTreeProjectItemObject


export const dataFolderTree = state => state.dataFolderTree
export const categoryFolderMapping = state => state.categoryFolderMapping
//export const reloadTreeFolderComponet = state => state.reloadTreeFolderComponet
export const reloadAfterDeleteTreeFolderItem = state => state.reloadAfterDeleteTreeFolderItem
export const selectedTreeFolderItemObject = state => state.selectedTreeFolderItemObject



export const createProjectForm = state => state.createProjectForm
export const selectedProjectRow = state => state.selectedProjectRow


export const bomDescription = state => state.bomDescription

export const selectedPartBomRow = state => state.selectedPartBomRow
export const isBomInProject = state => state.isBomInProject
export const selectedDocument = state => state.selectedDocument

export const subfolderForm = state => state.subfolderForm
export const variantFolderForm = state => state.variantFolderForm

export const selectedBomRow = state => state.selectedBomRow

export const variants = state => state.variants

export const delegatedResource = state => state.delegatedResource

export const isBom = state => state.isBom
export const importBomTypeForm = state => state.importBomTypeForm
export const createBomVariantForm = state => state.createBomVariantForm
export const bomPartObjectForm = state => state.bomPartObjectForm

export const checkboxVariant = state => state.checkboxVariant

export const selectedSearchPartRows = state => state.selectedSearchPartRows

export const noIpcImage = state => state.noIpcImage

export const bomProperties = state => state.bomProperties

export const projectSpecForm = state => state.projectSpecForm


// WEBPACK FOOTER //
// ./src/store/getters.js